import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class AddProducts extends Component{
	constructor(){
        super();

        this.createProduct = this.createProduct.bind(this);
        this.state = {
          userId : "",
          user :{},
          unitsList : {},
          categoryList : {},
        };
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
              var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/");
            }
        }); 

        var units = ref.child("Units")
            units.on("value", function(snap){
                this.setState({
                    unitsList : snap.val()
                })
            }.bind(this))

        var cat = ref.child("Categories")
            cat.on("value", function(snap){
                this.setState({
                    categoryList : snap.val()
                })
            }.bind(this))    
    } 

    componentWillUnmount(){
    	this.listener()  
    }

    addProduct(product){
    	ref.child("Products").push(product).then(alert("New Products has been added"))
    }

    createProduct(event){
    	event.preventDefault();
        if (!isNaN(this.price_4MM.value) && !isNaN(this.price_5MM.value) 
            && !isNaN(this.price_6MM.value) && !isNaN(this.price_8MM.value)
            && !isNaN(this.laborPrice_4MM.value) && !isNaN(this.laborPrice_5MM.value)
            && !isNaN(this.laborPrice_6MM.value) && !isNaN(this.laborPrice_8MM.value)             
            ){
        	const product={
        		name: this.name.value,
                dimension : this.dimension.value,
        		price_4MM: this.price_4MM.value,
                price_5MM: this.price_5MM.value,
                price_6MM: this.price_6MM.value,
                price_8MM: this.price_8MM.value,
                category : this.category.value,
        		desc: this.desc.value,
        		unit: this.unit.value,
                status : "Active",
                laborPrice_4MM :this.laborPrice_4MM.value,
                laborPrice_5MM :this.laborPrice_5MM.value,
                laborPrice_6MM :this.laborPrice_6MM.value,
                laborPrice_8MM :this.laborPrice_8MM.value
                
            }

        	this.addProduct(product);
        	this.productForm.reset();
        }else{
            alert("price must be a number")
        }
    }

   

	render(){
                   
	    return (
	    	<div id="page-wrapper">
	            <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
	                <Sidebar  role={this.state.user.role} />
	                <div id="main-container">
	                    <Header />
	                    <div id="page-content">
	                        <Title title="Add Product" />
	                        <div className="block">
                                <div className="block-title">
                                    <h2><i className="fa fa-pencil"></i> <strong>Product</strong> Information</h2>
                                </div>
						    	<form className="form-horizontal form-bordered" ref={(input) => {this.productForm=input}}  onSubmit={(e)=>this.createProduct(e)}>

						    		<div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Name</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.name=input}} type="text" required/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Category</label>
                                        <div className="col-md-4">
                                            <select id="product-category" ref={(input) =>{this.category=input}} className="form-control" >
                                                
                                               {                                               

                                                    Object.keys(this.state.categoryList).map(function (key){
                                                        let list = this.state.categoryList[key]
                                                        return <option value={list.category} key={key}> {list.category} </option>
                                                    }.bind(this))
                                                        
                                                }
                                                    
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Unit</label>
                                        <div className="col-md-4">
                                            <select id="product-unit" ref={(input) =>{this.unit=input}} className="form-control" >
                                                
                                               { 
                                                    Object.keys(this.state.unitsList).map(function (key){
                                                        let list = this.state.unitsList[key]
                                                        return <option value={list.unit} key={key}> {list.unit} </option>
                                                    }.bind(this))
                                                        
                                                }
                                                    
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Dimension for Main Product </label>                                        
                                            <div className="col-md-4">                                                
                                                <input className="form-control" ref={(input) => {this.dimension=input}} type="text" />
                                            </div>                                        
                                    </div>

                                    <div className="row nomarginLR">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (.4MM)</label>
                                            <div className="col-md-6">
                                            	<div className="input-group">
    	                                            <div className="input-group-addon"><i className="fa fa-rub"></i></div>
    	                                            <input className="form-control" ref={(input) => {this.price_4MM=input}} type="text" required />
    	                                        </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (.4MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.laborPrice_4MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row nomarginLR">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (.5MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.price_5MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (.5MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.laborPrice_5MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row nomarginLR">
                                        <div className="col-md-1">
                                        </div>
                                        <div className=" col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (.6MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.price_6MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (.6MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.laborPrice_6MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row nomarginLR">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (.8MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.price_8MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (.8MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" ref={(input) => {this.laborPrice_8MM=input}} type="text" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Description</label>
                                        <div className="col-md-6">
                                            <textarea className="form-control" rows="3" ref={(input) =>{this.desc=input}} required></textarea>
                                        </div>
                                    </div>

							    	<div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Add Product</button>
                                        </div>
                                    </div>
						    	</form>
	                        </div>
	                    </div>
	                    <Footer />
	                </div>
	            </div>
	        </div>
		);
	}
}

export default  AddProducts;



// WEBPACK FOOTER //
// ./src/components/AddProducts.js